import { render, staticRenderFns } from "./CustomerLocationsComponent.vue?vue&type=template&id=534e0ee7"
import script from "./CustomerLocationsComponent.vue?vue&type=script&lang=js"
export * from "./CustomerLocationsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports